<template>
  <div class="account-system">
    <router-view></router-view>
    <footer @click="goJump()">&copy;2014-2017 京ICP备13001365号-1 北京屏芯科技有限公司版权所有</footer>
  </div>
</template>
<script>
  import { setCookie, removeCookie, getCookie } from '@util/cookie';
  import { setGrayItems } from '@util/setGray';
  import { checkGrayItem } from '@util/handleGrayByLocalstorage';

  export default {
    created () {
      removeCookie('ACCOUNAT_GRAY');
      removeCookie('ACCOUNAT_PWD_GRAY');
      removeCookie('ACCOUNAT_NAME');
      this.createScript('//pv.sohu.com/cityjson?ie=utf-8').then(res => {
        setGrayItems(returnCitySN["cip"]);
      });
    },
    methods: {
      createScript (url) {
        return new Promise((resolve, reject) => {
          let script = document.createElement('script');
          script.setAttribute('src', url);
          script.setAttribute('type', 'text/javascript');
          document.body.appendChild(script);
          script.onload = () => {
            resolve();
          };
          script.onerror = () => {
            reject();
          };
        });
      },
      goJump () {
        window.open('https://beian.miit.gov.cn/');
      },
    }
  };
</script>
<style lang="less">
  .account-system {
    .main {
      margin: 140px auto 60px;
    }
    .el-form {
      .el-input {
        width: auto;
      }
      .el-input__inner {
        width: 360px;
        height: 36px;
      }
      .el-form-item__label {
        padding-right: 30px;
      }
      .sm-input {
        .el-input__inner {
          width: 216px;
        }
        .sm-input-right {
          width: 130px;
          height: 36px;
          margin-left: 14px;
        }
      }
      .el-radio + .el-radio {
        margin-left: 100px;
      }
      .el-button {
        width: 360px;
        height: 40px;
      }
    }
    .el-step {
      .el-step__head {
        .el-step__icon {
          width: 60px;
          height: 60px;
          font-size: 26px;
          color: #fff;
          border-radius: 50%;
        }
        &.is-process, &.is-wait {
          .el-step__icon {
            background: #bfcbd9;
            border-color: #bfcbd9;
          }
        }
        &.is-finish {
          .el-step__icon {
            border-color: #409EFF;
            background: #409EFF;
          }
        }
        .el-step__line {
          height: 6px;
          top: 28px;
          .el-step__line-inner {
            border-width: 3px !important;
          }
        }
      }
      .el-step__main {
        .el-step__title {
          &.is-process {
            color: #bfcbd9;
          }
          &.is-finish {
            color: #409EFF;
          }
        }
      }
    }
    footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 30px;
      line-height: 30px;
      border-top: 1px solid #dcdcdc;
      color: #9b9b9b;
      font-size: 12px;
      text-align: center;
      background: #fff;
      z-index: 999;
    }
  }
</style>



// WEBPACK FOOTER //
// Account.vue?fa2eb936